// src/components/SignOut.jsx
//
// Clears the locally-cached logged-in user and sends them back to
// the login page. Reached via the sidebar's "Sign out" link and the
// Header's user-menu "Sign out" button.

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_ORIGIN, clearAuthToken } from "../config/apiConfig";

export default function SignOut() {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("currentUser");
    // NEW: also drop the JWT (see apiConfig.js) -- without this, the
    // token stays in localStorage after "signing out," and anyone
    // reusing that browser could still hit protected API routes with
    // it until it naturally expires.
    clearAuthToken();
    // IMPL-03: also clear the HttpOnly session cookie -- page JS can't
    // remove an HttpOnly cookie itself, so this has to go through the
    // backend. Fire-and-forget: sign-out proceeds either way, since
    // the localStorage token clear above already ends the session for
    // every existing (header-based) API call.
    fetch(`${API_ORIGIN}/logout`, { method: "POST", credentials: "include" }).catch(() => {});
    navigate("/", { replace: true });
  }, [navigate]);

  return (
    <div className="container mt-5 text-center">
      <p>Signing out...</p>
    </div>
  );
}